export const projects = [
  {
    slug: 'intuit-yoga',
    title: 'Intuit Yoga',
    description: "I created this website for my mom's yoga business. The site is used for basic information about her services and for user signups for her classes. The site is built with plain HTML, CSS and Javascript on the frontend with a simple PHP backend.",
    images: ['./images/intuit_yoga_1.png', './images/intuit_yoga_2.png', './images/intuit_yoga_3.png'],
    colors: ['#6f99de', '#bdbdbd'],
    gridPosition: { colStart: 1, colEnd: 2, rowStart: 2, rowEnd: 3 },
    techStack: ['HTML', 'CSS', 'JavaScript', 'PHP'],
  },
  {
    slug: 'uvmaps',
    title: 'UVMaps',
    description: "UVMaps was a project I worked on with a team of 4 other students for my Mobile Developement class. The goal of this project was to integrate the UVM course schedule with a map component to help students find their way to the buildings that their classes were in. This app was built using SwiftUI and intended to be used on iPhones.",
    images: ['./images/uvmaps_1.png', './images/uvmaps_2.png', './images/uvmaps_3.png'],
    colors: ['#0f4d0d', '#a4a81d'],
    gridPosition: { colStart: 3, colEnd: 3, rowStart: 1, rowEnd: 3 },
    techStack: ['SwiftUI', 'iOS'],
  },
  {
    slug: 'salvation-suppers',
    title: 'Salvation Suppers',
    description: "Along with one other developer, I created a website for a local non-profit in Burlington VT, focussed on providing free meals to people in need. This site provides basic information about the organization and allows people to sign up to volunteer. The site is build with a Flask backend and plain HTML, CSS and Javascript for the frontend",
    images: ['./images/salvation_suppers_1.png', './images/salvation_suppers_2.png', './images/salvation_suppers_3.png'],
    colors: ['#960c0c', '#000000'],
    gridPosition: { colStart: 2, colEnd: 3, rowStart: 2, rowEnd: 3 },
    techStack: ['Flask', 'HTML', 'CSS', 'JavaScript'],
  },
  {
    slug: 'city-market-stocking',
    title: 'City Market Stocking System',
    description: "This is one of my on-going projects. I am creating a management web app for the City Market Co-op in Burlington VT. This app is intended to be used by the stocking team to manage their daily tasks. The app is built with a Typescript frontend and a Node JS backend.",
    images: [],
    colors: ['#b7b7b7', '#6f6f6f'],
    gridPosition: { colStart: 1, colEnd: 3, rowStart: 1, rowEnd: 2 },
    techStack: ['TypeScript', 'Node.js'],
  },
  {
    slug: 'chess',
    title: 'Chess',
    description: "This was my final project for the Software Development course at UVM. Along with 3 other teammates, we created a single/multiplayer chess game from scratch. We wrote this web app in Flask with Object oriented Python for the backend. For the frontend we used HTML, CSS and Javascript.",
    images: ['./images/chess_1.png', './images/chess_2.png', './images/chess_3.png'],
    colors: ['#a38c67', '#5e4215'],
    gridPosition: { colStart: 1, colEnd: 2, rowStart: 3, rowEnd: 5 },
    techStack: ['Flask', 'Python', 'HTML', 'CSS', 'JavaScript'],
  },
  {
    slug: 'secure-signin',
    title: 'Secure Signin',
    description: "This was my project for the Intro to Cybersecurity course at UVM. I created a secure signin system using a combination of HTML, CSS, Javascript with a Flask backend. The system uses a combination of hashing and salting to store passwords securely in a database using SQLite. We also got exposure to giving different permissions to different users.",
    images: [],
    colors: ['#fc03c2', '#641ebd'],
    gridPosition: { colStart: 2, colEnd: 4, rowStart: 3, rowEnd: 3 },
    techStack: ['Flask', 'SQLite', 'HTML', 'CSS', 'JavaScript'],
  },
  {
    slug: 'quizlet-competition',
    title: 'Quizlet Competition',
    description: "This is another one of my on-going projects. Along with 2 other developers we are creating the Snake game with a slight twist. In our version there are multiple fruits and you have to eat the correct fruit corresponding to the correct answer to a Quizlet question. This app is built with Typescript and Node JS.",
    images: [],
    colors: ['#7583FF', '#0A092D'],
    gridPosition: { colStart: 2, colEnd: 3, rowStart: 4, rowEnd: 4 },
    techStack: ['TypeScript', 'Node.js'],
  },
  {
    slug: 'devil-takes-a-holiday',
    title: 'Devil Takes a Holiday',
    description: "I created this website for a local cocktail bar in Burlington VT. The site provides basic info as well as a menu of the cocktails and a way to contact and reserve private events. The site is a purely frontend site built with React JS and using JSON files to store data.",
    images: ['./images/devil_1.png', './images/devil_2.png', './images/devil_3.png'],
    colors: ['#000000', '#808080'],
    gridPosition: { colStart: 3, colEnd: 4, rowStart: 4, rowEnd: 4 },
    techStack: ['React'],
  },
];

export const getProjectBySlug = (slug) => projects.find((p) => p.slug === slug);

export const isValidProjectSlug = (slug) => projects.some((p) => p.slug === slug);
